import {takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as rts from './receiptTrackingSlice';
import * as uis from '../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../Auth';
import { getReceiptsApi, findReceiptsApi, generatePDFReport, getUnsortedReceiptsApi, getMasterReceiptsApi } from './receiptTrackingAPI';


export function* onLoadReceiptTrackingStartAsync({ payload }){

    try{
        
        yield put(rts.actions.startCall({ callType: rts.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.queryParams
            }
        };

        const response = yield call(getReceiptsApi, payload.deptId, reqBody);        

        if(response.status === 200){
            let totalCount = response.data.length;
            let entities = response.data;
            
            yield put(rts.actions.sortedReceiptsFetched({totalCount, entities}));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 412){
            let msg = error.response.data;
            
            yield put(rts.actions.receiptMaxLimitReached({ msg }));
        } else if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());

        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error retrieving receipt tracking records."
            }));

            yield put(rts.actions.catchError({
                callType: rts.callTypes.list,
                error: "There was an error retrieving receipt tracking records."
            }));
        }
    }
};

export function* onLoadMasterReceiptsStartAsync({ payload }){

    try{
        
        yield put(rts.actions.startCall({ callType: rts.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.queryParams
            }
        };

        const response = yield call(getMasterReceiptsApi, payload.deptId, reqBody);        

        if(response.status === 200){
            let totalCount = response.data.length;
            let entities = response.data;
            
            yield put(rts.actions.masterReceiptsFetched({totalCount, entities}));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 412){
            let msg = error.response.data;
            
            yield put(rts.actions.receiptMaxLimitReached({ msg }));
        } else if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());

        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error retrieving receipt tracking records."
            }));

            yield put(rts.actions.catchError({
                callType: rts.callTypes.list,
                error: "There was an error retrieving receipt tracking records."
            }));
        }
    }
};

export function* onLoadUnsortedReceiptsStartAsync({ payload }){

    try{
        
        yield put(rts.actions.startCall({ callType: rts.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.queryParams
            }
        };
        
        const response = yield call(getUnsortedReceiptsApi, payload.deptId, reqBody);        

        if(response.status === 200){
            let totalCount = response.data.length;
            let entities = response.data;
            yield put(rts.actions.receiptsFetched({totalCount, entities}));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 412){
            let msg = error.response.data;
            
            yield put(rts.actions.receiptMaxLimitReached({ msg }));
        } else if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());

        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error retrieving receipt tracking records."
            }));

            yield put(rts.actions.catchError({
                callType: rts.callTypes.list,
                error: "There was an error retrieving receipt tracking records."
            }));
        }
    }

};

export function* onGeneratePDFReportStartAsync({ payload }){

    try{
        
        yield put(rts.actions.startCall({ callType: rts.callTypes.report }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.queryParams
            }
        };
        
        const response = yield call(generatePDFReport, reqBody);        

        if(response.status === 200){
            let dataString = response.data;
            yield put(rts.actions.receiptsReportFetched({ dataString }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 412){
            let msg = error.response.data;
            
            yield put(rts.actions.receiptMaxLimitReached({ msg }));
        } else if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            yield put(authReducerActions.loggedOut());

        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error generating the PDF report."
            }));

            yield put(rts.actions.catchError({
                callType: rts.callTypes.list,
                error: "There was an error generating the PDF report."
            }));
        }
    }

};

export function* onClearReportStringStartAsync (){

    try{
        
        yield put(rts.actions.clearReportString());
    }
    catch(error){

        console.log(error);


        yield put(uis.actions.showNotification({
            status:"error",
            title:"Error",
            message: "There was an error with clearing state."
        }));
    }

};

export function* onFindReceiptTrackingStartAsync({ payload }){

    try{
        
        yield put(rts.actions.startCall({ callType: rts.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.queryParams
            }
        };

        const response = yield call(findReceiptsApi, payload.deptId, reqBody);      

        if(response.status === 200){
            let totalCount = response.data.length;
            let entities = response.data;
            yield put(rts.actions.sortedReceiptsFetched({totalCount, entities}));
        } else if(response.status === 412){
            let msg = response.data;
            
            yield put(rts.actions.receiptMaxLimitReached({ msg }));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 412){
            let msg = error.response.data;
            
            yield put(rts.actions.receiptMaxLimitReached({ msg }));
        } else if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            yield put(authReducerActions.loggedOut());

        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error retrieving receipt records."
            }));

            yield put(rts.actions.catchError({
                callType: rts.callTypes.list,
                error: "There was an error retrieving receipt records."
            }));
        }
    }

};

export const actionTypes = {
    FetchReceipts: "[ReceiptsFetched] Fetch Agency Receipts API Action",
    FetchMasterReceipts: "[MasterReceiptsFetched] Fetch Agency Master Receipts API Action",
    FindReceipts: "[FindReceipts] Find Agency Receipts API Action",
    ReceiptsPDFReport: "[ReceiptsTrackingPDFReport] Generate Agency Receipt Tracking PDF Report",
    FetchUnsortedReceipts: "[Unsorted Receipts Fetched] Fetch Agency Unsorted Receipts API Action",
    ClearReportString: "[Clear Report String] Clear Report String Action"

};

export const actions = {

    fetchReceipts: (deptId, queryParams) => ({ type: actionTypes.FetchReceipts, payload: { deptId, queryParams } }),
    fetchMasterReceipts: (deptId, queryParams) => ({ type: actionTypes.FetchMasterReceipts, payload: { deptId, queryParams } }),
    findReceipts: (deptId, queryParams) => ({ type: actionTypes.FindReceipts, payload: { deptId, queryParams } }),
    receiptsPDFReport: (queryParams) => ({ type: actionTypes.ReceiptsPDFReport, payload: { queryParams } }),
    fetchUnsortedReceipts: (deptId, queryParams) => ({ type: actionTypes.FetchUnsortedReceipts, payload: { deptId, queryParams } }),
    clearReportString: () => ({ type: actionTypes.ClearReportString })

};

export function* fetchReceipts(){

    yield takeEvery(actionTypes.FetchReceipts, onLoadReceiptTrackingStartAsync);    
};

export function* fetchMasterReceipts(){

    yield takeEvery(actionTypes.FetchMasterReceipts, onLoadMasterReceiptsStartAsync);    
};

export function* findReceipts(){

    yield takeEvery(actionTypes.FindReceipts, onFindReceiptTrackingStartAsync);    
};

export function* receiptsPDFReport(){

    yield takeEvery(actionTypes.ReceiptsPDFReport, onGeneratePDFReportStartAsync);
};

export function* fetchUnsortedReceipts(){

    yield takeEvery(actionTypes.FetchUnsortedReceipts, onLoadUnsortedReceiptsStartAsync);
};

export function* clearReportString(){

    yield takeEvery(actionTypes.ClearReportString, onClearReportStringStartAsync);
};

const rtsSagas = [
    fork(fetchReceipts),
    fork(fetchMasterReceipts),
    fork(findReceipts),
    fork(receiptsPDFReport),
    fork(fetchUnsortedReceipts),
    fork(clearReportString)
];

export function* saga(){
    yield all ([...rtsSagas]);
};
